let result = {}
const funcJs = require.context('./endpoints', false, /\.js$/)
funcJs.keys().forEach(item => {
  const obj = funcJs(item)
  Object.entries(obj.default || obj).forEach(([key, val]) => {
    if (result[key]) {
      // console.warn(`有重复的api配置, 可能导致某些请求失效, [api name]: ${key}`)
    } else {
      result[key] =val
    }
  })
})

export default result